import Reward from './MyRewardItem';

export default Reward;
